module.exports = __webpack_public_path__ + "img/26.845d4134.svg";